import { NgModule } from "@angular/core";
import { MinutesToTextPipe } from "../../../pipe/minutes-to-text.pipe";

@NgModule({
    imports: [],
    exports: [MinutesToTextPipe],
    declarations: [MinutesToTextPipe],
})
export class MinutesToTextPipeModule {}
